import { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "About", href: "#about" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/70 border-b border-zinc-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-16 py-4 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-display font-black text-xl tracking-tight uppercase"
        >
          Slide<span className="text-[#002FA7]">&bull;</span>Ventures
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium tracking-wide uppercase text-zinc-700 hover:text-[#002FA7] transition-colors relative group"
            >
              {l.label}
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-[#002FA7] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta"
          className="hidden md:inline-flex items-center gap-2 bg-[#09090b] text-white px-5 py-3 text-xs font-bold uppercase tracking-widest hover:bg-[#002FA7] transition-colors duration-300"
        >
          Let&apos;s Talk <ArrowUpRight className="w-4 h-4" />
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden p-2"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-white border-t border-zinc-200 px-6 py-6 space-y-4"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block font-display text-2xl uppercase font-bold"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-cta"
            className="inline-flex items-center gap-2 bg-[#09090b] text-white px-5 py-3 text-xs font-bold uppercase tracking-widest"
          >
            Let&apos;s Talk <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      )}
    </header>
  );
}
